var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { TokenClient } from "../../../services/authentication/token-client.service";
import { transient } from "aurelia-dependency-injection";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { I18N } from 'aurelia-i18n';
var Register = /** @class */ (function () {
    function Register(tokenClient, notificationClientService, i18N) {
        this.tokenClient = tokenClient;
        this.notificationClientService = notificationClientService;
        this.i18N = i18N;
    }
    Register.prototype.submit = function () {
        var _this = this;
        if (this.password && this.confirmPassword == this.password) {
            this.submitting = true;
            return this.tokenClient.register({
                name: this.name,
                surname: this.surname,
                email: this.email,
                password: this.password,
                confirmPassword: this.confirmPassword
            }).then(function (response) {
                _this.submitting = false;
                location.reload();
            }).catch(function (error) {
                _this.submitting = false;
                console.log(error.response);
                _this.notificationClientService.show(_this.i18N.tr('error-text'), _this.i18N.tr('registration-failed-text'), NotificationType.Error);
            });
        }
        else if (this.confirmPassword != this.password) {
            this.notificationClientService.show(this.i18N.tr('error-text'), this.i18N.tr('password-and-confirm-password-do-not-match-text'), NotificationType.Error);
        }
        else {
            this.notificationClientService.show(this.i18N.tr('error-text'), this.i18N.tr('registration-failed-text'), NotificationType.Error);
        }
    };
    Register = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [TokenClient,
            NotificationClientService,
            I18N])
    ], Register);
    return Register;
}());
export { Register };
